var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
/**
 * 안정적인 SafeArea 래퍼 컴포넌트
 * react-native-safe-area-context의 SafeAreaView 간헐적 오동작 문제를 해결하기 위해
 * useSafeAreaInsets 훅을 사용하여 수동으로 패딩을 적용합니다.
 *
 * React Navigation 팀 권장 방식: https://reactnavigation.org/docs/handling-safe-area/
 */
export const SafeAreaWrapper = (_a) => {
    var { children, edges = ['top', 'bottom', 'left', 'right'], style } = _a, props = __rest(_a, ["children", "edges", "style"]);
    const insets = useSafeAreaInsets();
    const paddingStyle = {
        paddingTop: edges.includes('top') ? insets.top : 0,
        paddingBottom: edges.includes('bottom') ? insets.bottom : 0,
        paddingLeft: edges.includes('left') ? insets.left : 0,
        paddingRight: edges.includes('right') ? insets.right : 0,
    };
    return (_jsx(View, Object.assign({ style: [paddingStyle, style] }, props, { children: children })));
};
